// extracted by mini-css-extract-plugin
export default {"textContainer":"privacypolicy_textContainer__aZTB5"};